import { TFilterDealerGroup } from "~/shared/model/types";

export const APPEAL_STATUS = {
  initial: "initial",
  notRequired: "notRequired",
  draft: "draft",
  needInfo: "needInfo",
  review: "review",
  sent: "sent",
} as const;

export const RESOLUTION_STATUS = {
  sent: "sent",
  rejected: "rejected",
  accepted: "accepted",
  needInfo: "needInfo",
  review: "review",
  none: "none",
} as const;

export const MALUS_STATUS = {
  appealStarted: "appealStarted",
  true: true,
  false: false,
} as const;

type TAppealStatus = keyof typeof APPEAL_STATUS;
type TResolutionStatus = keyof typeof RESOLUTION_STATUS;
type TMalusStatus = keyof typeof MALUS_STATUS;

export interface IAppealFile {
  id: number;
  appealId: number;
  fileId: number;
  scope: string;
  name: string;
  link: string;
  mimeType: string;
  createdAt: string;
}

export interface IAppealSchema {
  id: number;
  dealerId: number;
  year: number;
  quarter: number;
  initialMalusStatus: boolean;
  malusStatus: boolean;
  status: "draft";
  contactPersonId: number | null;
  contactPersonFio: string;
  comment: string | null;
  needInfoComment: boolean | null;
  resolutionComment: string | null;
  createdAt: string;
  updatedAt: string;
  appealStatusFrontend: TAppealStatus;
  resolutionStatusFrontend: TResolutionStatus;
  malusStatusFrontend: TMalusStatus;
  files: IAppealFile[];
}

/**
 * Плоские значения фильтра апелляций из URL (query-параметры страницы
 * /staff/appeals). filterItems — строка со значениями через запятую
 * (так мультивыбор сериализуется фильтром Filter.Root).
 */
export type TAppealFilter = {
  year?: string;
  quarter?: string;
  filterBy?: string;
  malusStatus?: string;
  appealStatus?: string;
  resolutionStatus?: string;
  filterItems?: string;
};

export interface IAppealGetterParams {
  dealerGroup: TFilterDealerGroup;
  year: string;
  quarter: string;
  appealStatus: TAppealStatus;
  resolutionStatus: TResolutionStatus;
  malusStatus: TMalusStatus;
}

export interface IAppealSetterParams {
  id: number;
  contactPersonId: string;
  comment: string;
}

export interface IAppealResolveSetterParams {
  id: number;
  status: string;
  comment: string;
  fileIds: number[];
}

export interface IAppealSetterParams {
  id: string;
  contactPersonId: string;
  comment: string;
}

export interface IAppealFileSetterParams {
  appealId: number;
  fileId: string;
  scope: "appeal" | "resolution";
}

export interface IAppealSendCommentParams {
  id: string;
  comment: string;
}

export interface IAppealSetParams extends IAppealSetterParams {
  fileIds: string[];
  fileIdsOld: string[];
  scope: "appeal" | "resolution";
}

export interface IAppealResolveParams extends IAppealResolveSetterParams {
  fileIds: string[];
  fileIdsOld: string[];
  scope: "appeal" | "resolution";
}

export interface IAppealPeriodShema {
  createdAt: string;
  decisionDate: string;
  endDate: string;
  id: number;
  month: number;
  startDate: string;
  updatedAt: string;
  year: number;
}

export interface IAppealPeriodParams {
  year: number;
  month: number;
  startDate: string;
  endDate: string;
  decisionDate: string;
}
export interface IAppealDecision {
  id: number;
  malusStatus: boolean;
  resolutionComment: string;
  fileIds: number[];
}
